import React from 'react';
import { Link } from 'react-router-dom'

import logo from './assets/yongbo.png';
import S from './header.module.less';
import LoginState from './LoginState';

const Header = () => (
  <div className={S.wrapper}>
    <header className={`main ${S.header}`}>
      <div className={S.logo}>
        <Link to='/'>
          <img src={logo} alt='' />
          <span>永播</span>
        </Link>
      </div>
      
      <div className={S.login}>
        <LoginState />
      </div>
    </header>
  </div>
);

// class Header extends Component {
//   render() {
//     return (
//       <div className={S.wrapper}>
//         <header className={`main ${S.header}`}>
//           <div className={S.logo}>
//             <Link to='/'>
//               <img src={logo} alt='' />
//               <span>永播</span>
//             </Link>
//           </div>
          
//           <div className={S.login}>
//             <LoginState />
//           </div>
//         </header>
//       </div>
//     );
//   }
// }

export default Header;
